import React from "react";
import SectionHeading from "./SectionHeading";
import { LANDING } from "@/constants/testIds";

const PILLARS = [
  {
    title: "Tangible Collateral",
    body:
      "Secured against plant, equipment, real estate, receivables and inventory where appropriate.",
  },
  {
    title: "Contracted Cash Flow",
    body:
      "Preference for offtake, contracted utilisation and recurring revenue characteristics.",
  },
  {
    title: "Structural Seniority",
    body:
      "Senior or super-senior positioning with intercreditor and security packages.",
  },
  {
    title: "Governance Rights",
    body:
      "Board observation, information and protective consent rights.",
  },
];

const DownsideProtection = () => {
  return (
    <section
      data-testid={LANDING.downsideProtection}
      className="relative py-32 lg:py-44 border-t border-[var(--kr-line-soft)] overflow-hidden"
    >
      {/* faint architectural backdrop */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none opacity-[0.07]"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1565793298595-6a879b1d9492?auto=format&fit=crop&w=2400&q=70')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "grayscale(100%)",
        }}
      />

      <div className="relative max-w-[1480px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5">
          <SectionHeading
            index="09"
            label="Asset-Backed Downside Protection"
            title={
              <>
                Capital structured for
                <br />
                <span className="italic text-[var(--kr-gold)]">resilience</span>{" "}
                first.
              </>
            }
          />
        </div>
        <div className="lg:col-span-7">
          <p className="text-[var(--kr-text-muted)] text-[17px] leading-[1.85] max-w-[60ch] mb-14">
            Each mandate within the intended investment framework is
            underwritten with a preference for tangible asset coverage,
            cash-flow durability and structural protections. Capital is
            targeted where collateral, contracts and control rights compound to
            support capital preservation and enhance downside protection across
            a range of operating outcomes.
          </p>

          <div className="grid sm:grid-cols-2 gap-0 border-t border-l border-[var(--kr-line)]">
            {PILLARS.map((p) => (
              <div
                key={p.title}
                className="p-8 border-r border-b border-[var(--kr-line)]"
              >
                <h4 className="font-serif-display text-[1.35rem] text-[var(--kr-text)] mb-4">
                  {p.title}
                </h4>
                <p className="text-[var(--kr-text-muted)] text-[14.5px] leading-[1.7]">
                  {p.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownsideProtection;
